import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "next-i18next";
import Navbar from "../components/Nav/Nav";
import Footer from "../components/Footer/Footer";
import NavHook from "../components/Nav/NavHook";
import Head from "next/head";
import { trackZipcodeEntered } from "../utils/helpers/tracking";
import RefreshedFooter from "../components/RefreshedFooter/RefreshedFooter";

export default function Zipcode({ navigation, footer }) {
  const [zipCode, setZipCode] = useState("");
  const zipCodeRegex = /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/;
  const [isNotValid, setIsNotValid] = useState(false);
  const [lang, setLang] = useState("");
  const errorRef = useRef(null);
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const router = useRouter();

  useEffect(() => {
    const topLevelDomain = window.location.hostname.split(".").pop();
    setLang(topLevelDomain === "es" ? "es" : "fr");
  }, []);

  function checkZipCode(e) {
    e.preventDefault();
    axios
      .get(
        `${
          process.env.NEXT_PUBLIC_FAIT_MAISON_URL
        }/delivery/zipcheck/${lang}/${zipCode.trim()}`
      )
      .then((res) => {
        if (res.data) {
          trackZipcodeEntered(zipCode, "home", lang, true);
          router.push(`/baskets?zipcode=${zipCode}`);
          localStorage.setItem("zipcode", JSON.stringify(zipCode));
          setIsEmpty(false);
        } else {
          trackZipcodeEntered(zipCode, "home", lang, false);
          setIsNotValid(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function limitDigits(input, maxDigits) {
    if (input?.value?.length > maxDigits) {
      input.value = input.value.slice(0, maxDigits);
    }
  }

  function handleChange(e) {
    limitDigits(e.target.value, 5);
    setZipCode(e.target.value);
  }

  return (
    <>
      <Head>
        <title>Bene Bono</title>
        <meta
          property="og:title"
          content="Bene Bono | Cestas Ecológicas y Anti Desperdicio"
        />
        <meta
          property="og:site_name"
          content="Bene Bono"
        />
        <meta
          property="og:url"
          content={`benebono.${lang}`}
        />
        <meta
          property="og:description"
          content=""
        />
        <meta
          property="og:type"
          content="website"
        />
        <meta
          property="og:image"
          content="https://img.plasmic.app/img-optimizer/v1/img/c44d43862fdbf580d7139ef62c2c6ffa.png?q=75&f=webp"
        />
        {process.env.NODE_ENV !== "production" && (
          <meta
            name="robots"
            content="noindex,nofollow"
          />
        )}
      </Head>
      <Navbar links={navigation.links} />
      <form
        onSubmit={(e) => (zipCode.match(zipCodeRegex) ? checkZipCode(e) : null)}
        className="zipcode_container"
      >
        <h1>{t("zipcode.title")}</h1>
        <input
          ref={inputRef}
          onChange={handleChange}
          type="text"
          placeholder={t("input.zipcode.placeholder")}
          maxLength={5}
          inputMode="numeric"
          pattern="[0-9]{5}"
        />
        <input
          className="submit_button"
          type="submit"
          value={t("button.baskets")}
        />

        {isNotValid ? (
          <p
            ref={errorRef}
            className="error_zipcode"
          >
            {t("error.message.delivery")}{" "}
            <a
              className="signup_zipcode"
              href={
                lang === "es"
                  ? `https://tally.so/r/mVGLxj?cp=${zipCode}`
                  : `https://tally.so/r/wQOVYm?cp=${zipCode}`
              }
            >
              {t("subscription.wait.list.link")}
            </a>{" "}
            {t("susbcription.wait.list")}
          </p>
        ) : null}
      </form>
      <RefreshedFooter links={footer.links} />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const mainNav = await NavHook(locale, "main");
  const navigation = {
    links: mainNav,
  };

  const footerNav = await NavHook(locale, "footer");
  const footer = {
    links: footerNav,
  };

  return {
    props: {
      navigation,
      footer,
      locale,
    },
    revalidate: 120,
  };
}
